import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Logo from '../../assets/images/logo.png';
import { Link } from 'react-router-dom';
import AuthContext from '../../authContext';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import firebase from 'firebase/app';
import { useHistory, useLocation } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles({
  header: {
    height: '55px',
    display: 'flex',
    alignItems: 'center',
    // Prevent the user from selecting the logo.
    userSelect: 'none',
    msUserSelect: 'none',
    msTouchSelect: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    cursor: 'default'
  },
  icon: {
    height: '48px',
    margin: '4px 4px 4px 100px'
  },
  profilePhoto: {
    width: '48px',
    height: '48px',
    margin: '4px 100px 4px 4px'
  },
  container: {
    marginLeft: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  createButton: {
    marginRight: '10px'
  },
  divider: {
    width: '86%',
    margin: 'auto',
    top: '56px'
  },
  link: {
    textDecoration: 'none'
  }
});

const Header = () => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const history = useHistory();
  const location = useLocation();

  const isSignedIn = currentUser !== null;
  const isCreatePage = location.pathname === '/create';

  const onSignInButtonClicked = () => {
    if (isSignedIn) {
      firebase.auth().signOut();

      history.push('/projects');
    } else {
      const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

      firebase.auth().signInWithPopup(googleAuthProvider);
    }
  };

  const onCreateProjectButtonClicked = () => {
    history.push('/create');
  };

  return (
    <>
      <header className={classes.header}>
        <Link to="/">
          <img src={Logo} alt="Logo" className={classes.icon} />
        </Link>
        <Link to="/" className={classes.link}>
          <Typography
            variant="h5"
            color="textSecondary"
            component="p"
          >
            FutureFunder
        </Typography>
        </Link>
        <div className={classes.container}>
          {
            (isSignedIn && !isCreatePage) &&
            <Button
              variant="contained"
              color="primary"
              onClick={onCreateProjectButtonClicked}
              className={classes.createButton}
            >
              Create New Project
          </Button>
          }
          <Button
            variant="contained"
            color="primary"
            onClick={onSignInButtonClicked}
          >
            {isSignedIn ? "Logout" : "Sign in w/ Google"}
          </Button>
          <Avatar
            alt={currentUser !== null ? currentUser.displayName : 'Guest'}
            src={currentUser !== null ? currentUser.photoURL : ''}
            className={classes.profilePhoto}
          />
        </div>
      </header>
      <Divider className={classes.divider} />
    </>
  );
};

export default Header;
